var modules_b21bc4dc = {"socialsIcons":"Socials_module_socialsIcons__d8c33e0a"};
import "../../../assets/5Ur40iWY.css";

export { modules_b21bc4dc as default };
//# sourceMappingURL=Socials.module.less.js.map
